import script from "./MobilePreview.vue?vue&type=script&lang=ts&setup=true"
export * from "./MobilePreview.vue?vue&type=script&lang=ts&setup=true"

import "./MobilePreview.vue?vue&type=style&index=0&id=1c8bce03&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c8bce03"]])

export default __exports__